import { useGlobalState } from "@hooks/useGlobalState";
import AppStore from "@stores/AppStore";
import { useEffect } from "react";

let initializing = false;

const useAppStore = (): AppStore => {
  const [appStore] = useGlobalState("appStore");

  useEffect(() => {
    const init = async () => {
      try {
        appStore.setIsLoading(true);
        appStore.setIsInitializing(true); // TODO: redundant?

        // TODO: any app startup goop

        appStore.setInitialized(true);
      } finally {
        appStore.setIsInitializing(false); // TODO: redundant?
        appStore.setIsLoading(false);
      }
    };

    if (!initializing) {
      initializing = true;
      init();
    }
  }, [appStore.isAuthenticated]);

  return appStore;
};

export default useAppStore;
